import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#E2AD30", dark: "#B58519", contrastText: "#252920" },
    secondary: { main: "#C65D38", contrastText: "#FFFFFF" },
    tertiary: { main: "#7F8C61" },
    background: { default: "#F8F6ED", paper: "#FFFDF7" },
    text: { primary: "#252920", secondary: "#747767" },
    divider: "#E2DFCF",
  },
  shape: { borderRadius: 14 },
  breakpoints: { values: { xs: 0, sm: 600, md: 950, lg: 1200, xl: 1536 } },
  typography: {
    fontFamily: '"Inter", "Arial", sans-serif',
    h1: { fontWeight: 600, letterSpacing: "-0.05em" },
    h2: { fontWeight: 600, letterSpacing: "-0.035em" },
    h3: { fontWeight: 600, letterSpacing: "-0.025em" },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: "#F8F6ED" } } },
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 28, padding: "10px 22px" } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" }, rounded: { borderRadius: 16 } } },
    MuiCard: { styleOverrides: { root: { border: "1px solid #E2DFCF", boxShadow: "0 8px 28px rgba(65, 70, 39, 0.06)" } } },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: "#FFFDF7" }, notchedOutline: { borderColor: "#D8D7C5" } } },
    MuiTableCell: { styleOverrides: { head: { backgroundColor: "#EEEDE3", fontWeight: 600 }, root: { borderColor: "#E2DFCF" } } },
    MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: "#363D2D" } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 20 } } },
  },
});

export default theme;
